import * as THREE from 'three';
import { normalizePath, dataUrl } from '../util/path';
import { BinaryReader } from '../util/binaryreader';

// TODO: Fix these
global.ROSE_DATA_PATH = config.dataPath ? config.dataPath : '/data/';

global.ZZ_SCALE_IN = 0.01;
global.ZZ_SCALE_OUT = 100;
global.ZZ_TICK_PER_SEC = 4800;

export class ROSELoader {
  static load(path: any, callback: any, onError?: (err: any) => void) {
    // Check for errors.
    const normPath = normalizePath(path);
    if (normPath !== path) {
      //console.warn('Unnormalized path used.', path);
      path = normPath;
    }

    const loader = new THREE.FileLoader();
    loader.setResponseType('arraybuffer');
    loader.load(dataUrl(path), (buffer: any) => {
      callback(new BinaryReader(buffer));
    }, undefined, onError);
  }
}

export const ZZ_BLEND = {
  ZERO: 1,
  ONE: 2,
  SRC_COLOR: 3,
  INV_SRC_COLOR: 4,
  SRC_ALPHA: 5,
  INV_SRC_ALPHA: 6,
  DEST_ALPHA: 7,
  INV_DEST_ALPHA: 8,
  DEST_COLOR: 9,
  INV_DEST_COLOR: 10,
  SRC_ALPHA_SAT: 11,
  BOTH_SRC_ALPHA: 12,
  BOTH_INV_SRC_ALPHA: 13,
  BLEND_FACTOR: 14,
  INV_BLEND_FACTOR: 15
};

export const convertZnzinBlendType = (znzin: any) => {
  switch(znzin) {
    case ZZ_BLEND.ZERO:
      return THREE.ZeroFactor;
    case ZZ_BLEND.ONE:
      return THREE.OneFactor;
    case ZZ_BLEND.SRC_COLOR:
      return THREE.SrcColorFactor;
    case ZZ_BLEND.INV_SRC_COLOR:
      return THREE.OneMinusSrcColorFactor;
    case ZZ_BLEND.SRC_ALPHA:
      return THREE.SrcAlphaFactor;
    case ZZ_BLEND.INV_SRC_ALPHA:
      return THREE.OneMinusSrcAlphaFactor;
    case ZZ_BLEND.DEST_ALPHA:
      return THREE.DstAlphaFactor;
    case ZZ_BLEND.INV_DEST_ALPHA:
      return THREE.OneMinusDstAlphaFactor;
    case ZZ_BLEND.DEST_COLOR:
      return THREE.DstColorFactor;
    case ZZ_BLEND.INV_DEST_COLOR:
      return THREE.OneMinusDstColorFactor;
    case ZZ_BLEND.SRC_ALPHA_SAT:
      return THREE.SrcAlphaSaturateFactor;
  }

  console.warn('Encountered unknown d3d blending type:', znzin);
  return THREE.OneFactor;
};

export const ZZ_BLEND_OP = {
  ADD: 1,
  SUBTRACT: 2,
  REV_SUBTRACT: 3,
  MIN: 4,
  MAX: 5
};

export const convertZnzinBlendOp = (znzin: any) => {
  switch(znzin) {
    case ZZ_BLEND_OP.ADD:
      return THREE.AddEquation;
    case ZZ_BLEND_OP.SUBTRACT:
      return THREE.SubtractEquation;
    case ZZ_BLEND_OP.REV_SUBTRACT:
      return THREE.ReverseSubtractEquation;
  }

  if (renderer.supportsBlendMinMax()) {
    if (znzin === ZZ_BLEND_OP.MIN) {
      return THREE.MinEquation;
    } else if (znzin === ZZ_BLEND_OP.MAX) {
      return THREE.MaxEquation;
    }
  } else {
    if (znzin === ZZ_BLEND_OP.MIN || znzin === ZZ_BLEND_OP.MAX) {
      return THREE.AddEquation;
    }
  }

  console.warn('Encountered unknown d3d blending op:', znzin);
  return THREE.AddEquation;
};
